module.exports = __webpack_public_path__ + "img/L_321_325.b1f62d47.png";